module.exports = __webpack_public_path__ + "static/img/cont64 (5).bb1559a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (5).jpg
// module id = gjZy
// module chunks = 0